import React from "react";
import EventCalendarContainer from "./calendar";
import Layout from "../Layout/container";
import GuideVideoModalController from "../../components/GuideVideoModal/Controller";

function index(props) {
  return (
    <>
      <GuideVideoModalController pageKey="calendar" />
      <Layout upgradeBanner={{ top: true }}>
        <EventCalendarContainer />
      </Layout>
    </>
  );
}

export default index;
